const NAMESPACE = "pcInput";

const KEYS = {
    remainingCharsLabel: "remainingCharsLabel"
};

const MESSAGES = {
    [KEYS.remainingCharsLabel]: {
        value: "Remaining characters: {remainingChars}",
        comment: "The number of characters remaining in an input element"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
